import theme from "../theme"

export const cardBoxShadow = `box-shadow: ${theme.shadows[10]}`
export const cardBorderRadius = `border-radius: ${theme.shape.cardBorderRadius}px`
